import { flow, types } from 'mobx-state-tree';
import { Metrics } from '../../http-requests';
import { RequestStateModel } from './general-models';

const RequestsStatesModel = types.model({
  updateMetricsStates: types.optional(RequestStateModel, {}),
});

export const MetricsStore = types
  .model({
    requestsStates: types.optional(RequestsStatesModel, {}),
  })
  .actions((self) => ({
    updateMetrics: flow(function* (operations_type: string) {
      try {
        self.requestsStates.updateMetricsStates.loadingStates();

        const response = yield Metrics.UpdateMetrics({ operations_type });

        self.requestsStates.updateMetricsStates.successStates();
        return response;
      } catch (e) {
        self.requestsStates.updateMetricsStates.errorStates();
        console.error(e);
      } finally {
        self.requestsStates.updateMetricsStates.finallyStates();
      }
    }),
  }));
